module.exports = __webpack_public_path__ + "static/img/image002.95c3b26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image002.png
// module id = mYKW
// module chunks = 1